import React, { useEffect, useMemo, useRef, useState } from 'react'
import Header from '../../../layouts/Header'
import "../../../assets/styles/local/OcrForm.css";
import { CiSquareMinus, CiSquarePlus } from "react-icons/ci";
import { FaChevronLeft, FaChevronRight, FaPlusCircle, FaRegTrashAlt } from 'react-icons/fa';
import { MdOutlineAttachFile } from 'react-icons/md';
import { IoDocumentOutline } from 'react-icons/io5';
import { Worker, Viewer, SpecialZoomLevel, ViewMode } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import useCustomZoomPlugin from './plugins/ocr-pdf-viewer-plugin';
import { Menu, MenuItem, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ClearOcrTempData, OcrDocumentSave, OcrDocumentUpdate, OcrGetOcrDocumentById, OcrProcessDocument } from '../../../redux/actions/action';
import { useHistory, useParams } from 'react-router-dom';
import Loader from '../../../components/Dailogs/Loader';
import moment from 'moment';
import { BsCheck2Circle, BsCopy, BsThreeDots, BsThreeDotsVertical, BsTrash } from "react-icons/bs";
import { v4 as uuidv4 } from 'uuid';
import TextareaAutosize from 'react-textarea-autosize';
import LogoSmall from "../../../assets/images/logo-small.png";
import floatingSound from "../../../assets/audios/floating-notification-tone.wav";
import { toast } from "react-toastify";

const ObjectState = {
  UnChanged: 0,
  Modified: 1,
  Deleted: 2,
  Added: 3
}

const OcrForm = () => {
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const ocrProcessedDocument = useSelector(x => x.user.ocrProcessedDocument);
  const ocrDocumentSaved = useSelector(x => x.user.ocrDocumentSaved);
  const ocrDocumentById = useSelector(x => x.user.ocrDocumentById);
  const isEditMode = useMemo(() => Boolean(id), [id]);

  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (Object.keys(ocrProcessedDocument).length > 0 && !id) {
      let newData = { ...ocrProcessedDocument };
      newData.docDate = moment(newData.docDate).isValid() ? newData.docDate.split('T')[0] : "";
      newData.docDueDate = moment(newData.docDueDate).isValid() ? newData.docDueDate.split('T')[0] : "";
      setData(newData);
      setLoading(false);
    }
  }, [ocrProcessedDocument, id]);

  useEffect(() => {
    if (Object.keys(ocrDocumentById).length > 0 && id) {
      let newData = { ...ocrDocumentById };
      newData.docDate = moment(newData.docDate).isValid() ? newData.docDate.split('T')[0] : "";
      newData.docDueDate = moment(newData.docDueDate).isValid() ? newData.docDueDate.split('T')[0] : "";
      setData(newData);
      setLoading(false);
    }
  }, [ocrDocumentById, id]);

  useEffect(() => {
    if (id) {
      dispatch(OcrGetOcrDocumentById(id));
      setLoading(true);
    }

    return () => {
      dispatch(ClearOcrTempData())
    }
  }, [id])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let oldData = { ...data };
    oldData[name] = value;
    setData({ ...oldData });
  }

  const isValidObject = (mappedData) => {
    return mappedData.items.every(
      (item) => item.itemID !== null && item.itemDescription?.trim() !== ""
    );
  }

  const handleSaveDocument = () => {

    setIsSubmitted(true);
    if (Object.keys(data).length > 0) {
      let mappedData = { ...data };
      if(isValidObject(mappedData)){
        mappedData.items.forEach((x) => {
          x.vat = x.vat ? x.vat : 0;
          x.unitPrice = x.unitPrice ? x.unitPrice : 0;
          x.qty = x.qty ? x.qty : 0;
          x.total = x.total ? x.total : 0;
          x.discount = x.discount ? x.discount : 0;
          x.totalInclVat = x.totalInclVat ? x.totalInclVat : 0;
        })
        if (isEditMode) {
          dispatch(OcrDocumentUpdate(mappedData))
        } else {
          dispatch(OcrDocumentSave(mappedData))
        }
        setLoading(true);
      } else {
        ValidationNotification()
      }
    }
  }

  useEffect(() => {
    if (ocrDocumentSaved) {
      dispatch(ClearOcrTempData())
      setLoading(false);
      history.goBack();
    }
  }, [ocrDocumentSaved])

  const handleAddMissingLineClick = () => {
    const emptyRow = {
      "id": uuidv4(),
      "itemID": null,
      "itemDescription": "",
      "unitPrice": 0,
      "qty": 0,
      "total": 0,
      "discount": 0,
      "vat": 0,
      "totalInclVat": 0,
      "poNo": null,
      "projectId": null,
      "status": "0",
      "productPartId": null,
      "objectState": ObjectState.Added
    };
    let oldData = { ...data };
    oldData?.items?.unshift(emptyRow);
    setData(oldData);
  }

  const handleColumnInputChange = (name, itemId, value) => {
    let oldData = { ...data };
    let index = oldData.items.findIndex(x => x.id === itemId);
    oldData.items[index][name] = value;
    if (oldData.items[index].objectState !== ObjectState.Added) {
      oldData.items[index].objectState = ObjectState.Modified;
    }
    setData(oldData);
  }

  const handleActionClick = (itemId, action) => {
    let oldData = { ...data };
    let index = oldData.items.findIndex(x => x.id === itemId);
    switch (action) {
      case "Accept":
        oldData.items[index].status = "1";
        break;
      case "Duplicate":
        break;
      case "Delete":
        if (oldData.items[index].objectState == ObjectState.Added) {
          oldData.items[index].splice(index, 1);
        } else {
          oldData.items[index].objectState = ObjectState.Deleted;
        }
        break;
    }
    setData(oldData);
  }

  return (
    <>
      <Header leftComponent={<HeaderLeftComponent />} />
      {loading && <div className="ocr-page-loader"><Loader /></div>}
      <div className='row mx-4'>
        <div className='col-12'>
          <div className="d-flex align-items-center justify-content-end gap-3 mb-2">
            <button className='cancel_cont_btn' onClick={() => history.goBack()}>Cancel</button>
            <button className='add-buttons' onClick={handleSaveDocument}>{isEditMode ? 'Update' : 'Add'}</button>
          </div>
        </div>
        <div className='col-12 ocr-form-resp'>
          <div className='d-flex gap-3 ocr-form'>
            <OcrDocumentUploadArea file={data?.fileStream} onDocumentUpload={() => setLoading(true)} clearLocalData={() => setData({})} />
            <div className='card border-0 flex-grow-1 p-2'>
              <div className='card-body'>
                <div className='row mb-4'>
                  <div className='col-3'>
                    <TextField
                      label="Supplier Account ID"
                      type="text"
                      name='supplierAccountID'
                      value={data?.supplierAccountID || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-6'>
                    <TextField
                      label="Supplier Name"
                      type="text"
                      name='supplierName'
                      value={data?.supplierName || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-3'>
                    <TextField
                      label="Supplier VAT No."
                      type="text"
                      name='supplierVatNo'
                      value={data?.supplierVatNo || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                </div>
                <div className='row mb-4'>
                  <div className='col-4'>
                    <TextField
                      label="PO No"
                      type="text"
                      name='orderNumber'
                      value={data?.orderNumber || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-4'>
                    <TextField
                      label="Project Id"
                      type="text"
                      name='projectId'
                      value={data?.projectId || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-4'>
                    <TextField
                      label="Invoice id"
                      type="text"
                      name='invoiceId'
                      value={data?.invoiceId || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                </div>
                <div className='row mb-4'>
                  <div className='col-3'>
                    <TextField
                      label="Doc ID"
                      type="text"
                      name='docID'
                      value={data?.docID || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-2'>
                    <TextField
                      label="Type Doc"
                      type="text"
                      name='docType'
                      value={data?.docType || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-2'>
                    <TextField
                      label="Doc Date"
                      type="text"
                      name='docDate'
                      value={data?.docDate || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-2'>
                    <TextField
                      label="Doc Total Amount"
                      type="text"
                      name='docTotalAmount'
                      value={data?.docTotalAmount || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                  <div className='col-3'>
                    <TextField
                      label="Doc Due Date"
                      type="text"
                      name='docDueDate'
                      value={data?.docDueDate || ""}
                      onChange={handleInputChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </div>
                </div>
                {
                  Object.keys(data).length > 0 &&
                  <div className='d-flex'>
                    <label className='d-flex align-items-center gap-2' style={{ color: "#323232", fontSize: 14, cursor: "pointer" }} onClick={handleAddMissingLineClick}>
                      <FaPlusCircle color='#95A7C6' />
                      Add Missing Line
                    </label>
                  </div>
                }
                <div className='table-responsive'>
                  <table className='table ocr-table'>
                    <thead>
                      <tr>
                        <th style={{ width: 10 }}></th>
                        <th style={{ width: 100 }}>Item ID</th>
                        <th style={{ width: 150 }}>Item Description</th>
                        <th style={{ width: 80 }}>Unit Price</th>
                        <th style={{ width: 50 }}>Qty</th>
                        <th style={{ width: 100 }}>Total</th>
                        <th style={{ width: 80 }}>Discount</th>
                        <th style={{ width: 30 }}>VAT</th>
                        <th style={{ width: 100 }}>Total Incl. VAT</th>
                        <th style={{ width: 120 }}>Status</th>
                        <th style={{ width: 10 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.items?.filter(x => x.objectState !== ObjectState.Deleted).map((item, index) => {
                        return (
                          <tr key={`ocr-document-item-${item.id}`} className={`line-status-${item.status}`}>
                            <td><div className={`status-icon`} /></td>
                            <td style={{ background: !item.itemID && isSubmitted ? "#ffe6e6" : ""}}>
                              <ColumnInput
                                key={`${item.id}-item.itemID`}
                                value={item.itemID}
                                onUpdateValue={(value) => handleColumnInputChange("itemID", item.id, value)}
                                placeholder={item.objectState === ObjectState.Added ? "Add item" : ""}
                                showError={isSubmitted}
                              />
                            </td>
                            <td style={{ background: !item.itemDescription && isSubmitted ? "#ffe6e6" : ""}}>
                              <ColumnInput
                                key={`${item.id}-item.itemDescription`}
                                value={item.itemDescription}
                                onUpdateValue={(value) => handleColumnInputChange("itemDescription", item.id, value)}
                                placeholder={""}
                                showError={isSubmitted}
                              />
                            </td>
                            <td>
                              <ColumnInput
                                key={`${item.id}-item.unitPrice`}
                                value={item.unitPrice}
                                onUpdateValue={(value) => handleColumnInputChange("unitPrice", item.id, value)}
                                placeholder={""}
                                onlyNumber={true}
                              />
                            </td>
                            <td>
                              <ColumnInput
                                key={`${item.id}-item.qty`}
                                value={item.qty}
                                onUpdateValue={(value) => handleColumnInputChange("qty", item.id, value)}
                                placeholder={""}
                                onlyNumber={true}
                              />
                            </td>
                            <td>
                              <ColumnInput
                                key={`${item.id}-item.total`}
                                value={item.total}
                                onUpdateValue={(value) => handleColumnInputChange("total", item.id, value)}
                                placeholder={""}
                                onlyNumber={true}
                              />
                            </td>
                            <td>
                              <ColumnInput
                                key={`${item.id}-item.discount`}
                                value={item.discount}
                                onUpdateValue={(value) => handleColumnInputChange("discount", item.id, value)}
                                placeholder={""}
                                onlyNumber={true}
                              />
                            </td>
                            <td>
                              <ColumnInput
                                key={`${item.id}-item.vat`}
                                value={item.vat}
                                onUpdateValue={(value) => handleColumnInputChange("vat", item.id, value)}
                                placeholder={""}
                                onlyNumber={true}
                              />
                            </td>
                            <td>
                              <ColumnInput
                                key={`${item.id}-item.totalInclVat`}
                                value={item.totalInclVat}
                                onUpdateValue={(value) => handleColumnInputChange("totalInclVat", item.id, value)}
                                placeholder={""}
                                onlyNumber={true}
                              />
                            </td>
                            <td><div className='status-name'>{item.status === "1" ? "Matched" : "Not recognized"}</div></td>
                            <td>
                              <ColumnActions key={`row-actions-${item.id}`} onActionClick={(action) => handleActionClick(item.id, action)} />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const ColumnActions = ({ onActionClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onMenuSelect = (name) => {
    onActionClick(name);
    handleClose();
  }
  return (
    <>
      <BsThreeDotsVertical onClick={handleClick} />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem disableTouchRipple disableRipple>
          <div className='d-flex align-items-center justify-content-end w-100'>
            <div style={{ width: 20 }} onClick={handleClose}>
              <BsThreeDots />
            </div>
          </div>
        </MenuItem>
        <MenuItem onClick={() => onMenuSelect("Accept")}>
          <div className='d-flex align-items-center gap-2'>
            <div style={{ width: 20 }}>
              <BsCheck2Circle />
            </div>
            Accept
          </div>
        </MenuItem>
        <MenuItem onClick={() => onMenuSelect("Duplicate")}>
          <div className='d-flex align-items-center gap-2'>
            <div style={{ width: 20 }}>
              <BsCopy />
            </div>
            Duplicate
          </div>
        </MenuItem>
        <MenuItem onClick={() => onMenuSelect("Delete")}>
          <div className='d-flex align-items-center gap-2'>
            <div style={{ width: 20 }}>
              <BsTrash />
            </div>
            Delete
          </div>
        </MenuItem>
      </Menu>
    </>
  )
}

const ColumnInput = ({ value, onUpdateValue, onlyNumber, placeholder, showError=false }) => {
  const onInputChange = (value) => {
    let formattedValue = value;
    if (onlyNumber && value) {
      const regex = /^[0-9]*\.?[0-9]*$/;
      if (!regex.test(formattedValue)) {
        return
      }
    }
    onUpdateValue(formattedValue);
  }
  return (
    <TextareaAutosize
      cacheMeasurements={false}
      value={value || ""}
      onChange={e => onInputChange(e.target.value)}
      placeholder={placeholder || ""}
      style={{ border: "none", width: "100%", background: showError && !value ? "#ffe6e6" : '' }}
    />
  )
}

const HeaderLeftComponent = () => {
  return (
    <div className='d-flex align-items-center gap-4'>
      <div className='ocr-form-header-primary'>OCR - Accounts Payable Process</div>
      <div className='ocr-form-header-secondary'>New Document</div>
    </div>
  )
}

const ValidationNotification = () => {
  toast.dismiss();
  toast(<ValidationNotificationMessage />, {
    icon: () => <img src={LogoSmall} width={35} />,
    className: "app-notification",
    data: {
      sound: new Audio(floatingSound),
    },
  });
};

const ValidationNotificationMessage = () => {
  return (
    <div>
      <label> Validation Error:</label>
      <br />
      <label style={{ color: "red" }}>
        {" "}
        {"Please Add all the Mandatory Fields"}
      </label>
    </div>
  );
};

const OcrDocumentUploadArea = ({ file, onDocumentUpload, clearLocalData }) => {
  const dispatch = useDispatch();
  const customZoomPluginInstance = useCustomZoomPlugin();
  const { zoomTo } = customZoomPluginInstance;
  const fileRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const history = useHistory();

  const onAttachemntClick = () => {
    fileRef.current?.click();
  }

  useEffect(() => {
    if (file) {
      const binaryString = window.atob(file);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setUploadedFile(url);
    }
  }, [file])

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      dispatch(ClearOcrTempData());
      dispatch(OcrProcessDocument(files[0]));
      onDocumentUpload();
      history.replace('/ocr-add')
    }
  }

  const handleScalePdf = (value) => {
    let newValue = scale + value;
    if (newValue >= 0.6 && newValue <= 2) {
      setScale(newValue)
      zoomTo(newValue)
    }
  }

  const removeAttachedDocument = () => {
    setUploadedFile(null);
    fileRef.current.value = null;
    fileRef.current.files = null;
    dispatch(ClearOcrTempData());
    clearLocalData();
    history.replace('/ocr-add')
  }

  return (
    <div className='card border-0 p-2 ocr-form-left'>
      <div className='card-body'>
        <div className="ocr-document-container">
          <input type='file' className='d-none' accept=".pdf" ref={fileRef} onChange={handleFileChange} />
          <label className='ocr-document-container-header'>Doc Scanned</label>
          <div className='ocr-document-action-container'>
            <div className='ocr-document-action'>
              <CiSquarePlus size={22} onClick={() => handleScalePdf(0.1)} />
            </div>
            <div className='ocr-document-action'>
              <CiSquareMinus size={22} onClick={() => handleScalePdf(-0.1)} />
            </div>
            <div className='ocr-document-action'>
              <FaRegTrashAlt size={20} color='#707070' onClick={removeAttachedDocument} />
            </div>
            <div className='ocr-document-action'>
              <IoDocumentOutline size={22} color='#707070' />
            </div>
            <div className='ocr-document-action'>
              <MdOutlineAttachFile size={22} color='#707070' onClick={onAttachemntClick} />
            </div>
          </div>
          <div className='ocr-document-preview-container'>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
              {uploadedFile &&
                <Viewer fileUrl={uploadedFile} plugins={[customZoomPluginInstance]} viewMode={ViewMode.SinglePage} defaultScale={0.6} withCredentials={true} />
              }
            </Worker>
          </div>
          <div className='ocr-document-pagination'>
            1-2 <FaChevronLeft color='#A5A5A5' size={12} /> 1 <FaChevronRight color='#A5A5A5' size={12} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OcrForm